/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { convertToLocalTime } from 'my-phorest/utils/local-datetime-helpers';
import { format as formatDate } from 'my-phorest/utils/local-date-helpers';
import { format as formatTime } from 'my-phorest/utils/local-time-helpers';
import smsIcon from 'my-phorest/assets/images/sms.svg';
import whatsappIcon from 'my-phorest/assets/images/whatsapp.svg';

export default class ChatsListChatComponent extends Component {
  @service intl;
  @service twoWayChat;
  smsIconSrc = smsIcon;
  whatsappIconSrc = whatsappIcon;

  get lastMessageDate() {
    const date = new Date(this.args.message.sentDateTime);
    const today = new Date();

    if (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    ) {
      return formatTime(
        convertToLocalTime(this.args.message.sentDateTime),
        this.intl
      );
    }

    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (
      date.getDate() === yesterday.getDate() &&
      date.getMonth() === yesterday.getMonth() &&
      date.getFullYear() === yesterday.getFullYear()
    ) {
      return this.intl.t('global.yesterday');
    }

    return formatDate(this.args.message.sentDateTime, this.intl, 'tiny');
  }

  @action
  markAsUnread() {
    const clientId = this.args.clientId;
    const uuid = this.args.message.uuid;
    this.twoWayChat.markConversationAsUnreadTask.perform(clientId, uuid);
  }
}
